import type { ResolvedScope } from './types';
export interface RouteScopePolicy {
  /** Exact pathname reviewed by the integration owner. */
  pathname: string;
  presentationFilters: readonly string[];
  pathBound: boolean;
  /** Explicit destination for leaving a bound record, not an inferred ID replacement. */
  destinationPath?: string;
}
const selectionKeys = /^(environmentScope|environmentId|env|portal|portalId|resource|resourceId|job|jobId|commandId|planId|selection|source|destination|target|recovery.*)$/i;
export function buildScopeTransition(location: { pathname: string; search: string }, next: ResolvedScope,
  policy?: RouteScopePolicy): { kind: 'navigate'; pathname: string; search: string } | { kind: 'blocked'; reason: string } {
  if (next.kind !== 'all' && next.kind !== 'environment') return { kind: 'blocked', reason: 'unresolved-scope' };
  if (!policy || policy.pathname !== location.pathname) return { kind: 'blocked', reason: 'route-policy-required' };
  if (policy.pathBound && !policy.destinationPath) return { kind: 'blocked', reason: 'bound-record-migration-required' };
  const pathname = policy.destinationPath ?? location.pathname;
  if (!pathname.startsWith('/') || pathname.startsWith('//') || /[?#\\]/.test(pathname)) return { kind: 'blocked', reason: 'invalid-destination' };
  const current = new URLSearchParams(location.search), params = new URLSearchParams();
  for (const key of new Set(policy.presentationFilters)) {
    if (selectionKeys.test(key)) return { kind: 'blocked', reason: 'selection-is-not-presentation' };
    for (const value of current.getAll(key)) params.append(key, value);
  }
  if (next.kind === 'all') params.set('environmentScope', 'all');
  else params.set('environmentId', next.environment.environmentId);
  return { kind: 'navigate', pathname, search: `?${params.toString()}` };
}
